module.exports = __webpack_public_path__ + "img/apple_logo@2x.19783e55.png";